class Toast {
  constructor() {
    // Prevent multiple containers
    if (!document.querySelector('#toast-container')) {
      this.container = document.createElement('div');
      this.container.id = 'toast-container';
      this.container.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 99999;
        display: flex;
        flex-direction: column;
        gap: 10px;
      `;
      document.body.appendChild(this.container);
    } else {
      this.container = document.querySelector('#toast-container');
    }
  }

  show(message, type = 'error', duration = 3000) {
    const toast = document.createElement('div');
    toast.textContent = message;
    toast.style.cssText = `
      background: ${type === 'error' ? '#f44336' : '#4CAF50'};
      color: white;
      padding: 12px 16px;
      border-radius: 6px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.2);
      opacity: 0;
      transform: translateX(100%);
      transition: transform 0.3s ease, opacity 0.3s ease;
      min-width: 200px;
      max-width: 300px;
      font-size: 14px;
    `;

    this.container.appendChild(toast);

    // Animate in
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(0)';
    });

    // Auto-hide
    setTimeout(() => this.hide(toast), duration);
  }

  hide(toast) {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(100%)';
    setTimeout(() => toast.remove(), 300);
  }
}

// Global instance
window.Toast = new Toast();
